"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
/** Footer for the bottom of the page. */
const Footer = (props) => react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)));
// hgg80
exports.default = withJourney_1.default('j-footer', Footer, { wrapsHref: false, collapseInModal: 'hidden' });
